import classnames from 'classnames';

import styles from './index.css';

export interface Option {
    label: string;
    value: number | string;
}

export interface SelectMenuProp {
    className?: string;
    options: Option[];
    onClickOption?: (value: Option) => void;
    reverse?: boolean;
}

const SelectMenu: React.FC<SelectMenuProp> = ({
    className,
    options = [],
    reverse,
    onClickOption = () => {},
}) => (
    <div className={classnames(styles.selectMenu, className)}>
        <div className={classnames(styles.optionWrapper, reverse && styles.reverse)}>
            {options.map((option) => (
                <div
                    key={option.value}
                    className={styles.option}
                    onClick={(event) => {
                        onClickOption(option);
                        event.stopPropagation();
                    }}
                    onKeyPress={() => {}}
                    role="menuitem"
                    tabIndex={0}
                >
                    {option.label}
                </div>
            ))}
        </div>
    </div>
);

export default SelectMenu;
